import { useSuiClient } from '@mysten/dapp-kit';
import { CoinBalance } from '@mysten/sui.js/client';
import { useQuery } from '@tanstack/react-query';
import { IConsts, SLP_TOKEN_DECIMALS, suiSymbolToSymbol } from 'sudo-ts-sdk';
import { TANSTACK_OWNED_POINTS_KEY } from '../utils/constants';
import { ITokenBalance } from './useAccountData';

export type CoinBalanceType = {
  balance: ITokenBalance[];
  address?: string;
  suiBalance: number;
};

export function useSudoCardBalance({
  consts,
  address,
}: {
  consts: IConsts;
  address: string;
}) {
  const provider = useSuiClient();

  return useQuery({
    queryKey: [TANSTACK_OWNED_POINTS_KEY, address],
    queryFn: async (): Promise<CoinBalanceType> => {
      if (!address) return { balance: [], address, suiBalance: 0 };

      const res = await provider.getAllBalances({ owner: address });

      let balances: CoinBalance[] = res;

      const suiBalance =
        balances
          .find(balance => balance.coinType === '0x2::sui::SUI')
          ?.totalBalance.toString() || '0';

      const scardBalance = {
        balance: balances.map(balance => {
          const symbol = suiSymbolToSymbol(balance.coinType, consts);
          const decimals =
            symbol === 'slp'
              ? SLP_TOKEN_DECIMALS
              : consts.coins[symbol]?.decimals ?? 9;
          return {
            symbol,
            balance: parseInt(balance.totalBalance.toString()) / 10 ** decimals,
          };
        }),
        address: address,
        suiBalance: parseInt(suiBalance),
      };

      return scardBalance;
    },
  });
}
